import React from 'react'
import { Link } from 'react-router-dom'

const Footer: React.FC = () => {
  return (
    <footer className="bg-surface-light border-t border-neutral-200">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-6">
          <div className="flex justify-center space-x-4 sm:space-x-6">
            <Link to="/generator" className="text-sm sm:text-base text-neutral-500 hover:text-brand-black transition-colors duration-200">
              llms.txt Generator
            </Link>
            <Link to="/validator" className="text-sm sm:text-base text-neutral-500 hover:text-brand-black transition-colors duration-200">
              llms.txt Validator
            </Link>
          </div>
          <div className="text-center sm:text-left">
            <p className="text-xs sm:text-sm leading-5 text-neutral-500">
              &copy; {new Date().getFullYear()} llms.txt Generator by AndaLabX. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer 